import { render } from "./InquiryBoardForm.vue?vue&type=template&id=4bc13f88&scoped=true"
import script from "./InquiryBoardForm.vue?vue&type=script&lang=js"
export * from "./InquiryBoardForm.vue?vue&type=script&lang=js"

import "./InquiryBoardForm.vue?vue&type=style&index=0&id=4bc13f88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bc13f88"]])

export default __exports__